// Format date
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

// Get screenshot URL
export const getScreenshotUrl = (screenshot) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  return `${BACKEND_URL}${screenshot.url}`;
};

// Get logo URL
export const getLogoUrl = (app) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  return app.logo_url ? `${BACKEND_URL}${app.logo_url}` : null;
};

// Share on Twitter
export const shareOnTwitter = (app) => {
  const text = `Check out ${app.app_name} on Emergent App Marketplace!`;
  const url = window.location.href;
  window.open(
    `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
    '_blank',
    'width=600,height=400'
  );
};

// Share on LinkedIn
export const shareOnLinkedIn = (app) => {
  const url = window.location.href;
  window.open(
    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    '_blank',
    'width=600,height=400'
  );
};

// Truncate text
export const truncate = (text, length) => {
  if (text.length <= length) return text;
  return text.substring(0, length) + '...';
};

// Get status color
export const getStatusColor = (status) => {
  const colors = {
    pending_review: 'bg-yellow-100 text-yellow-800',
    approved: 'bg-green-100 text-green-800',
    rejected: 'bg-red-100 text-red-800',
    changes_requested: 'bg-orange-100 text-orange-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};

// Get SLA status color
export const getSLAColor = (slaStatus) => {
  const colors = {
    green: 'bg-green-500',
    yellow: 'bg-yellow-500',
    red: 'bg-red-500',
  };
  return colors[slaStatus] || 'bg-gray-500';
};
